// Wait until DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
	var productEl = document.querySelector('.product');
	if (!productEl) return;

	// Utility to wait for required elements to exist
	function waitForElements(selector, callback) {
		var el = document.querySelector(selector);
		if (el) { callback(); return; }

		var observer = new MutationObserver(function () {
			if (document.querySelector(selector)) {
				observer.disconnect();
				callback();
			}
		});
		observer.observe(productEl, { childList: true, subtree: true });

		// Safety timeout — stop after 10s
		setTimeout(function () { observer.disconnect(); }, 10000);
	}

	waitForElements('.product-form__buttons', function () {

		// Ensure jQuery is available
		if (typeof jQuery === 'undefined') {
			console.error('jQuery is not loaded.');
			return;
		}

		var $ = jQuery;

		// Remove extra shop buttons from PDP page 
		$('.product .product-form__buttons .shopify-payment-button').remove();

		// Sticky ATC button
		$('.product-form__buttons').addClass('sticky');

		// Show Back to Top button on scroll
		window.addEventListener('scroll', function () {
			if (window.scrollY > 300) {
				$('#backToTop').fadeIn();
			} else {
				$('#backToTop').fadeOut();
			}
		}, { passive: true });

		// Scroll to top on click
		$('#backToTop').on('click', function () {
			$('html, body').animate({ scrollTop: 0 }, 600);
			return false;
		});

		// Move quantity into button area
		var $quantity = $('.product-form__quantity');
		var $buttons = $('.product-form__buttons');
		function getMobilePriceSource() {
			return $('.no-js-hidden[role="status"]').not('.pack-price-status-ref').first();
		}

		var $priceOriginal = getMobilePriceSource();

		if ($quantity.length && $buttons.length && !$quantity.closest('.qty-atc-row').length) {
			$quantity.prependTo($buttons);
		}

		function syncAtcVariantBehavior() {
			$priceOriginal = getMobilePriceSource();
			$('.mobile-price').remove();

			if ($quantity.length && $buttons.length && !$buttons.find('.product-form__quantity').length && !$quantity.closest('.qty-atc-row').length) {
				$quantity.prependTo($buttons);
			}
		}

		syncAtcVariantBehavior();

		// On resize
		window.addEventListener('resize', function () {
			syncAtcVariantBehavior();
		});

		var variantObserver = new MutationObserver(function () {
			syncAtcVariantBehavior();
		});

		if (document.body) {
			variantObserver.observe(document.body, {
				attributes: true,
				attributeFilter: ['class'],
				subtree: false
			});
		}

		var root = document.querySelector('[data-pdp-root]');
		if (root) {
			variantObserver.observe(root, {
				attributes: true,
				attributeFilter: ['class']
			});
		}

		//update price based on quantity selection
		// var regular = {}, sale = {};
 
		// function parsePrice($el) {
		// 	var text = $el.text().trim();
		// 	return {
		// 		prefix: (text.match(/^[^\d]+/) || ["$"])[0].trim(),
		// 		suffix: (text.match(/[^\d]+$/) || [""])[0].trim(),
		// 		value: parseFloat(text.replace(/[^0-9.]/g, ""))
		// 	};
		// }
	
		// function setBasePrices() {
		// 	regular = parsePrice($(".price-per-piece-wrapper .price-item--regular:first"));	
		// 	console.log(regular);
				
		// 	sale = parsePrice($(".price-per-piece-wrapper .price-item--sale:first"));		
		// }
	
		// function updateCartPrice() {
		// 	console.log(regular);
			
		// 	var qty = parseInt($(".product-form__buttons .quantity__input").val()) || 1;
		// 	console.log(qty);
			
		// 	$(".price__regular .price-item--regular").text(regular.prefix + (regular.value * qty).toFixed(2) + " " + regular.suffix);
		// 	$(".price__sale .price-item--sale, .price__sale .price-item--regular").text(sale.prefix + (sale.value * qty).toFixed(2) + " " + sale.suffix);
		// }
	
		// $(".product-form__buttons button[name='minus'], .product-form__buttons button[name='plus'], .quantity__input").on("click input", updateCartPrice);
	
		// setBasePrices();

	});

	// Yotpo review button + summary repositioning (merged, scoped observer)
	jQuery(function ($) {
		var reviewBtnDone = false;
		var summaryDone = false;

		var observer = new MutationObserver(function () {
			if (!reviewBtnDone) {
				var button = $('.product .yotpo-new-review-button');
				var target = $('.product .yotpo-bottom-line-summary');
				if (button.length && target.length) {
					button.appendTo(target);
					reviewBtnDone = true;
				}
			}

			if (!summaryDone) {
				var summary = $('.product .product-review-summaries-wrapper');
				var headerTarget = $('.product .yotpo-header-container');
				if (summary.length && headerTarget.length && !headerTarget.find('.product-review-summaries-wrapper').length) {
					summary.appendTo(headerTarget);
					summaryDone = true;
				}
			}

			if (reviewBtnDone && summaryDone) observer.disconnect();
		});

		observer.observe(productEl, { childList: true, subtree: true });
		setTimeout(function () { observer.disconnect(); }, 15000);
	});

});

// Fix media-gallery layout on tablet (≤1199px) — inline style beats all external CSS conflicts
(function () {
  function fixGalleryTabletLayout() {
    if (!document.body || !document.body.classList.contains('template-product-default')) return;

    var mediaGallery = document.querySelector('.product--thumbnail_slider media-gallery');
    if (!mediaGallery) return;
    if (window.innerWidth <= 1199) {
      mediaGallery.setAttribute('style', 'display: block !important; flex-direction: column !important;');
    } else {
      mediaGallery.removeAttribute('style');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixGalleryTabletLayout);
  } else {
    fixGalleryTabletLayout();
  }
  window.addEventListener('resize', fixGalleryTabletLayout, { passive: true });
})();

// Issue 9 — Add accessible titles to unlabeled iframes (Shopify analytics frames)
(function () {
  function labelUnnamedIframes() {
    document.querySelectorAll('iframe:not([title]):not([aria-label])').forEach(function (frame) {
      frame.setAttribute('title', 'Analytics Tracking');
    });
  }

  // Label any already-present iframes
  labelUnnamedIframes();

  // Watch for iframes injected after page load
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeName === 'IFRAME' && !node.title && !node.getAttribute('aria-label')) {
          node.setAttribute('title', 'Analytics Tracking');
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

function isNativeCartMode() {
  var root = document.documentElement;
  if (!root) return false;

  // Both cart-drawer A/B arms (control and v1) render a fully native Liquid
  // drawer with no UpCart runtime involved, so both must be treated as native
  // here. Previously only v1 matched, which left the UpCart-only accessibility
  // patches (Issues 5, 16, 17) and drawer observer active during the Control
  // arm, letting them patch ARIA/focus-trap state onto the native control
  // drawer alongside its own handling.
  if (
    root.dataset &&
    (root.dataset.cartExp === 'v1' ||
      root.dataset.cartExp === 'control' ||
      root.dataset.cartMode === 'v1' ||
      root.dataset.cartMode === 'control' ||
      root.dataset.cartMode === 'native')
  ) {
    return true;
  }
  if (root.classList && (root.classList.contains('cart-exp-v1') || root.classList.contains('cart-exp-control'))) return true;
  return root.classList && root.classList.contains('cro-v1');
}

// Issue 16 — Remove keyboard tabindex from UpCart cart heading
(function () {
  if (isNativeCartMode()) return;
  function removeCartHeadingTabindex() {
    document.querySelectorAll('.upcart-header-text[tabindex]').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  }

  // Run immediately in case element already exists
  removeCartHeadingTabindex();

  // Watch for UpCart injecting the heading dynamically
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node.querySelectorAll) return;
        node.querySelectorAll('.upcart-header-text[tabindex]').forEach(function (el) {
          el.removeAttribute('tabindex');
        });
        if (node.classList && node.classList.contains('upcart-header-text') && node.hasAttribute('tabindex')) {
          node.removeAttribute('tabindex');
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

// Issue 5 — Fix UpCart cart drawer ARIA dialog accessibility
(function () {
  if (isNativeCartMode()) return;
  var lastFocusedElement = null;

  // Collect all focusable elements within a container
  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), ' +
      'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  // Trap Tab focus inside the drawer
  function handleFocusTrap(container, event) {
    var focusable = getFocusableElements(container);
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey) {
        if (document.activeElement === first) {
          event.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }

  // Patch the UpCart drawer with ARIA dialog attributes
  function patchDrawer(drawer) {
    if (drawer.dataset.a11yPatched) return;
    drawer.dataset.a11yPatched = 'true';

    // ARIA dialog role and label
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');

    // Use existing heading as label if present, else fall back to aria-label
    var heading = drawer.querySelector('.upcart-header-text');
    if (heading) {
      if (!heading.id) heading.id = 'upcart-dialog-heading';
      drawer.setAttribute('aria-labelledby', 'upcart-dialog-heading');
    } else {
      drawer.setAttribute('aria-label', 'Shopping Cart');
    }

    // Focus trap + Escape to close
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var closeBtn = drawer.querySelector(
          '[data-upcart-close], .upcart-close-btn, button.upcart-close, ' +
          '[aria-label="Close"], [aria-label="close"], button[class*="close"]'
        );
        if (closeBtn) closeBtn.click();
        if (lastFocusedElement) {
          lastFocusedElement.focus();
          lastFocusedElement = null;
        }
        return;
      }
      handleFocusTrap(drawer, e);
    });
  }

  // Track the element that triggered cart open
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '[data-upcart-open], .upcart-cart-icon, ' +
      '#CartIconBubble, #cart-icon-bubble, [href*="/cart"], ' +
      '[aria-label*="cart" i], [class*="cart-icon"]'
    );
    if (trigger) lastFocusedElement = trigger;
  }, true);

  // Detect when UpCart injects or opens the drawer
  function observeDrawer() {
    var mutObs = new MutationObserver(function () {
      if (isNativeCartMode()) {
        mutObs.disconnect();
        return;
      }
      var drawer = document.querySelector(
        '.upcart-wrapper, .upcart-drawer, #upcart, ' +
        '[class*="upcart"][class*="drawer"], [class*="upcart"][class*="wrapper"]'
      );
      if (!drawer) return;

      // Patch structure
      patchDrawer(drawer);

      // Move focus into drawer when it becomes visible
      var isVisible = drawer.offsetParent !== null &&
                      getComputedStyle(drawer).display !== 'none' &&
                      getComputedStyle(drawer).visibility !== 'hidden';
      if (isVisible && !drawer.dataset.a11yFocused) {
        drawer.dataset.a11yFocused = 'true';
        var focusTarget = drawer.querySelector(
          '[data-upcart-close], .upcart-close-btn, button[class*="close"], button'
        );
        if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 80);
      }

      // Reset focused flag when drawer closes
      if (!isVisible && drawer.dataset.a11yFocused) {
        delete drawer.dataset.a11yFocused;
      }
    });

    mutObs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
})();

// Issue 17 — Give UpCart's real checkout button a stable id so the cart-drawer
// CRO test's "Checkout Click" goal (HTML Id = CartDrawer-Checkout) can also
// fire on the Control (live UpCart) experience, not just the V1 redesign.
(function () {
  if (isNativeCartMode()) return;

  function patchUpCartCheckoutId() {
    var btn = document.querySelector('.upcart-checkout-button:not(#CartDrawer-Checkout)');
    if (btn && !btn.id) btn.id = 'CartDrawer-Checkout';
  }

  patchUpCartCheckoutId();

  var observer = new MutationObserver(function (mutations) {
    if (isNativeCartMode()) {
      observer.disconnect();
      return;
    }
    var hasAddedElement = mutations.some(function (mutation) {
      return mutation.addedNodes.length > 0;
    });
    if (hasAddedElement) patchUpCartCheckoutId();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

// =============================================================================
// Issue 8 — Add aria-labels to Yotpo review carousel slides
// Issue 10 — Fix broken aria-labelledby references in dynamically-rendered carousels
// =============================================================================
(function () {
  'use strict';

  // Issue 8: Label each Yotpo review carousel slide with "Review X of Y"
  function labelYotpoSlides() {
    // Yotpo carousel renders slides as list items inside the widget
    var carousels = document.querySelectorAll(
      '.yotpo-widget-instance, [data-yotpo-instance-id]'
    );
    carousels.forEach(function (carousel) {
      if (carousel.dataset.a11yLabeled) return;

      // Target individual review slides — Yotpo uses these classes
      var slides = carousel.querySelectorAll(
        '.yotpo-carousel-review, [class*="reviewCarouselCard"], ' +
        '[class*="review-carousel-card"], [class*="carousel-item"]'
      );
      if (!slides.length) return;

      var total = slides.length;
      slides.forEach(function (slide, index) {
        if (!slide.getAttribute('aria-label')) {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', 'Review ' + (index + 1) + ' of ' + total);
        }
      });
      carousel.dataset.a11yLabeled = 'true';
    });
  }

  // Issue 10: Find any aria-labelledby pointing to a non-existent ID and fix it
  function fixBrokenAriaLabelledBy() {
    document.querySelectorAll('[aria-labelledby]').forEach(function (el) {
      var ids = el.getAttribute('aria-labelledby').split(/\s+/);
      var allExist = ids.every(function (id) {
        return id && document.getElementById(id);
      });
      if (!allExist) {
        // Build a label from the IDs that DO exist, discard the missing ones
        var labelParts = ids
          .map(function (id) {
            var ref = document.getElementById(id);
            return ref ? ref.textContent.trim() : null;
          })
          .filter(Boolean);

        if (labelParts.length) {
          // Replace broken aria-labelledby with a direct aria-label from existing refs
          el.removeAttribute('aria-labelledby');
          el.setAttribute('aria-label', labelParts.join(' '));
        } else {
          // No referenced elements exist at all — remove the broken attribute
          el.removeAttribute('aria-labelledby');
        }
      }
    });
  }

  function runFixes() {
    labelYotpoSlides();
    fixBrokenAriaLabelledBy();
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFixes);
  } else {
    runFixes();
  }

  // Re-run when Yotpo or other dynamic content injects into the DOM
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (relevant) runFixes();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Microsoft Clarity "Shop with AI" launcher offset.
   The launcher renders inside #ads-agent-host's shadow root, so theme CSS cannot reach it
   and the app exposes no position setting. Its margins come from a single --spacing-xxl,
   which moves it sideways as well as up, so instead we inject a stylesheet into the open
   shadow root that overrides only the launcher's bottom margin. The chat panel does not
   carry mb-xxl, so it is deliberately left untouched — containing the host instead was
   tried and threw the panel off-screen. */
(function () {
  var HOST_ID = 'ads-agent-host';
  var STYLE_ID = 'cm-agent-offset';

  // Sit the launcher on the same baseline as #backToTop, whose bottom is 32px site-wide
  // and 83px below 1200px (assets/custom.css), which still clears the sticky add-to-cart bar. Bottom edges are aligned rather than
  // centres because the launcher changes height as it expands and collapses, so a centre
  // match would drift; its bottom stays put. Both then clear the sticky add-to-cart bar.
  // transform is neutralised as well as the margin: the widget fades itself in with an
  // inline 'transform: translateY(-20px)' that it clears once visible, so its resting
  // height shifted by up to 20px and it drifted out of line with #backToTop. Horizontal
  // centring survives this - it does not come from the transform (translateX(-50%) here
  // double-shifts the launcher off the left edge). Only the entrance slide is lost; the
  // opacity fade still runs.
  // The agent dims the whole page behind its panel with a 50% black backdrop. Nothing in
  // the page's own styling changes - no colour variables, no section backgrounds - but the
  // first section reads as though it has changed colour, so the backdrop is made
  // transparent. It keeps pointer-events, so tapping outside the panel still closes it.
  // The agent renders the launcher with one of two anchorings depending on its state:
  // 'right-0 mr-xxl' or 'left-1/2 -translate-x-1/2', the latter centring it. Pin it to the
  // right in both by overriding left/right and supplying the inset the centred variant has
  // no margin for. Both transform and translate are cleared: the vertical entrance offset
  // comes through transform, while -translate-x-1/2 uses the standalone translate property,
  // so clearing only one leaves the launcher half its own width off the edge.
  function rulesFor() {
    return '.fixed.bottom-0.mb-xxl{' +
             'left:auto !important;right:0 !important;margin-right:24px !important;' +
             'margin-bottom:32px !important;' +
             'transform:none !important;translate:none !important;}' +
           '.fixed.inset-0.z-modal.bg-black{opacity:0 !important;}' +
           '@media screen and (max-width: 1199px){' +
             '.fixed.bottom-0.mb-xxl{margin-bottom:83px !important;}' +
           '}';
  }

  function apply(host) {
    var root = host.shadowRoot;
    if (!root) return;
    var rules = rulesFor();
    if (!rules) return;
    var style = root.querySelector('#' + STYLE_ID);
    if (style) {
      if (style.textContent !== rules) style.textContent = rules;
      return;
    }
    style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = rules;
    root.appendChild(style);
  }

  function attach(host) {
    apply(host);
    // The widget re-renders its own root when the panel opens and closes, which can drop
    // our stylesheet, so put it back whenever the root's children change.
    new MutationObserver(function () {
      apply(host);
    }).observe(host.shadowRoot, { childList: true });
  }

  function init() {
    var host = document.getElementById(HOST_ID);
    if (!host || !host.shadowRoot) return false;
    attach(host);
    return true;
  }

  if (!init()) {
    // The agent mounts asynchronously, well after DOMContentLoaded.
    var observer = new MutationObserver(function () {
      if (init()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 60000);
  }
})();

/* Scroll-position guard for the Microsoft Clarity "Shop with AI" agent.
   The agent locks background scrolling by setting position:fixed on <body> with no top
   offset, so the page underneath snaps to the top when the panel opens and the visitor's
   place is gone when it closes. Pin the body at the offset it was already at, and put the
   scroll position back when the lock lifts.

   The offset is tracked on scroll and pointerdown rather than read when the lock appears:
   a MutationObserver only runs after the style is applied, by which point position:fixed
   has already reset scrollY to 0, and coalesced scroll events can lag the resting position.

   Nothing is written to body.style while the panel is open - only on the lock and unlock
   transitions. Re-asserting the offset mid-session fought the agent's own teardown and
   left the panel stuck open. */
(function () {
  var pinned = false;
  var savedY = 0;
  var lastY = window.scrollY || 0;

  function bodyIsLocked() {
    return getComputedStyle(document.body).position === 'fixed';
  }

  function trackY() {
    if (!pinned && !bodyIsLocked()) {
      lastY = window.scrollY || document.documentElement.scrollTop || 0;
    }
  }

  window.addEventListener('scroll', trackY, { passive: true });
  window.addEventListener('pointerdown', trackY, { capture: true, passive: true });
  window.addEventListener('touchstart', trackY, { capture: true, passive: true });

  new MutationObserver(function () {
    var locked = bodyIsLocked();

    if (locked && !pinned) {
      // Something else already handled the offset - leave it alone.
      if (document.body.style.top && document.body.style.top !== '0px') return;
      if (!lastY) return;
      savedY = lastY;
      document.body.style.top = '-' + savedY + 'px';
      pinned = true;
    } else if (!locked && pinned) {
      pinned = false;
      document.body.style.top = '';
      window.scrollTo(0, savedY);
      lastY = savedY;
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['style'] });
})();
